module.exports = __webpack_public_path__ + "img/sticker-ru10x10.1e1a61ea.jpg";